import { z } from "zod";

export const buildClinicSchema = (t: (key: string) => string) =>
  z.object({
    name: z
      .string()
      .trim()
      .min(1, { message: t("validation.clinicNameRequired") })
      .min(2, { message: t("validation.clinicNameMin") })
      .max(100, { message: t("validation.clinicNameMax") }),
    address: z
      .string()
      .trim()
      .min(1, { message: t("validation.addressRequired") })
      .min(2, { message: t("validation.addressMin") })
      .max(100, { message: t("validation.addressMax") }),
    description: z
      .string()
      .trim()
      .min(1, { message: t("validation.descriptionRequired") })
      .min(2, { message: t("validation.descriptionMin") })
      .max(500, { message: t("validation.descriptionMax") }),
    website: z
      .string()
      .trim()
      .url({ message: t("validation.websiteInvalid") })
      .optional(),
    email: z
      .string()
      .trim()
      .min(1, { message: t("validation.emailRequired") })
      .email({ message: t("validation.invalidEmail") }),
    phone: z
      .string()
      .trim()
      .min(1, { message: t("validation.phoneRequired") })
      .min(2, { message: t("validation.phoneMin") })
      .max(20, { message: t("validation.phoneMax") }),
  });
